/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export const HTML_INCLUDE_LOAD = 'HTML_INCLUDE_LOAD';
export const loadHtmlInclude = actionCreator<String>(HTML_INCLUDE_LOAD);

export const HTML_INCLUDE_SET = 'HTML_INCLUDE_SET';
export const setHtmlInclude = actionCreator<{url: string, content: string}>(HTML_INCLUDE_SET);

export const LOAD_STATIC_HTML_FRAGMENTS = 'LOAD_STATIC_HTML_FRAGMENTS';
export const loadStaticHtmlFragments = actionCreator(LOAD_STATIC_HTML_FRAGMENTS);
